import { Delegate } from "vendor";
import { __accessCheck, __privateGet, __privateAdd, __privateSet, __privateMethod } from "theme";

let _retakeQuiz, retakeQuiz_fn, _validateNextQuestion, validateNextQuestion_fn, _previousQuestion, previousQuestion_fn, _nextQuestion, nextQuestion_fn, _delegate;

let QuizGHD = class extends HTMLElement {
	constructor() {
		super();
		
	    __privateAdd(this, _retakeQuiz);
		__privateAdd(this, _validateNextQuestion);
		__privateAdd(this, _previousQuestion);
		__privateAdd(this, _nextQuestion);
		__privateAdd(this, _delegate, new Delegate(this));
		
		__privateGet(this, _delegate).on("click", '[is="reset-quiz"]', __privateMethod(this, _retakeQuiz, retakeQuiz_fn).bind(this));
	    __privateGet(this, _delegate).on("click", '[data-answer-required] [data-option-value]', __privateMethod(this, _validateNextQuestion, validateNextQuestion_fn).bind(this));
	    __privateGet(this, _delegate).on("click", '[is="quiz-ghd-previous"]', __privateMethod(this, _previousQuestion, previousQuestion_fn).bind(this));
	    __privateGet(this, _delegate).on("click", '[is="quiz-ghd-next"]', __privateMethod(this, _nextQuestion, nextQuestion_fn).bind(this));
		
		this.quizQuestions = this.querySelectorAll('.quiz-question');
		this.currentQuestionIndex = 0;
		this.nextQuestionIndex = 1;
		this.prevQuestionIndex = -1;
	}
  
	connectedCallback() {
		let _this = this;
		if (this.shouldAppearAutomatically) {
			this.scoreTotalsSorted = JSON.parse(localStorage.getItem("theme:quiz:results"));
			if (window.customElements.get("compare-ghd")) {
				_this._displayResults();
			} else {
				customElements.whenDefined('compare-ghd').then(() => {
					_this._displayResults();
				});
			}
	    }
	}
  
	disconnectedCallback() {
	    __privateGet(this, _delegate).destroy();
	}
	
    get shouldAppearAutomatically() {
		return localStorage.getItem("theme:quiz:taken") === "true";
    }
	
	get productList() {
		return this.getAttribute('available-products').split(',');
	}
	
	get progressBar() {
		return this.querySelector('.quiz-progress-bar');
	}
	
	_displayResults() {
		let _this = this;
		
		this.querySelector('.quiz-primary-results [data-product-handle="' + this.scoreTotalsSorted[0][0] + '"]').removeAttribute('hidden');
		if (this.querySelector('compare-ghd')) {
		    this.querySelector('compare-ghd').dispatchEvent(new CustomEvent("quiz:result", { 
				detail: { 
					scoreTotals: _this.scoreTotalsSorted
				} 
			}));
		}
		
		localStorage.setItem('theme:quiz:results', JSON.stringify(this.scoreTotalsSorted));
		localStorage.setItem("theme:quiz:taken", "true");
		
		this.querySelector('.quiz-questions').setAttribute('hidden', 'hidden');
		this.querySelector('.quiz-results').removeAttribute('hidden');
	}
	
	_tallyTotals() {
		let _this = this;
		this.scoreTotals = {};
	    
		Array.from(this.querySelectorAll('input:checked')).forEach(function (item) {
			_this.productList.forEach(function (productListItem) {
				if (!_this.scoreTotals[productListItem]) {
					_this.scoreTotals[productListItem] = 0;
				};
				
				_this.scoreTotals[productListItem] += Number(item.getAttribute(productListItem));
			});
		});
		
		this.scoreTotalsSorted = [];
	  
		for (var item in this.scoreTotals) {
			this.scoreTotalsSorted.push([
				item, 
				this.scoreTotals[item],
				this.querySelector('.quiz-primary-results [data-product-handle="' + item + '"]').getAttribute('data-product-title')
			]);
		}

		this.scoreTotalsSorted.sort(function(a, b) {
			return b[1] - a[1];
		});
		
		this._displayResults();
	  
	}
};

_retakeQuiz = new WeakSet();
retakeQuiz_fn = function(event) {
	localStorage.removeItem('theme:quiz:results');
	localStorage.removeItem("theme:quiz:taken");
	location.reload();
};

_validateNextQuestion = new WeakSet();
validateNextQuestion_fn = function(event) {
	let questionWrapper = event.target.closest('.quiz-question');
	if (questionWrapper.querySelector('.button[disabled]')) {
		questionWrapper.querySelector('.button[disabled]').removeAttribute('disabled');
	}
};

_previousQuestion = new WeakSet();
previousQuestion_fn = function(event) {
	if (this.currentQuestionIndex - 1 >= 0) {
		this.quizQuestions[this.currentQuestionIndex].setAttribute('hidden', 'hidden');
		this.quizQuestions[this.prevQuestionIndex].removeAttribute('hidden');
  
		this.currentQuestionIndex = this.currentQuestionIndex -= 1;
		this.nextQuestionIndex = this.nextQuestionIndex -= 1;
		this.prevQuestionIndex = this.prevQuestionIndex -= 1;
	  
		gsap.to(
			this.progressBar,
			{
				width: (100 / this.quizQuestions.length) * (this.currentQuestionIndex + 1) + '%',
			}
		);
		window.scrollTo({ top: 0, behavior: "smooth" });
	}
};

_nextQuestion = new WeakSet();
nextQuestion_fn = function(event) {
	if (this.currentQuestionIndex + 1 <= (this.quizQuestions.length - 1)) {
		this.quizQuestions[this.currentQuestionIndex].setAttribute('hidden', 'hidden');
		this.quizQuestions[this.nextQuestionIndex].removeAttribute('hidden');
  
		this.currentQuestionIndex = this.currentQuestionIndex += 1;
		this.nextQuestionIndex = this.nextQuestionIndex += 1;
		this.prevQuestionIndex = this.prevQuestionIndex += 1;
	  
		gsap.to(
			this.progressBar,
			{
				width: (100 / this.quizQuestions.length) * (this.currentQuestionIndex + 1) + '%',
			}
		);
	} else {
		this._tallyTotals();
	}
	window.scrollTo({ top: 0, behavior: "smooth" });
};

_delegate = new WeakMap();

if (!window.customElements.get("quiz-ghd")) {
  window.customElements.define("quiz-ghd", QuizGHD);
}

export {
	QuizGHD
}